import React from "react";

const anchorTagRegex = /<a [^>]*>([^<]+)<\/a>/g;
const urlRegex = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/g;

const TextWithUrls = ({ text = "" }) => {
  
  let anchorWithID = [];

  let textWithHyperLink = text.replace(anchorTagRegex, (a, content,i) => {
    // replace anchor tag by id in text and saving that id to replace the anchor tag later
    const anchroId = `A-${Date.now()}-${i}`;
    anchorWithID.push({ id: anchroId, tag: a });
    return anchroId;
  });
  textWithHyperLink = textWithHyperLink.replace(
    urlRegex,
    (url) => `<a href="${url}" target="_blank">${url}</a>`
  );

  anchorWithID.forEach(({ id, tag }) => {
    textWithHyperLink = textWithHyperLink.split(id).join(tag);
  });

  return <span dangerouslySetInnerHTML={{ __html: textWithHyperLink }} />;
};

const ResearchSection = ({ researchToShow = "", county }) => {
  return (
    <div className="p-1 h-100">
      <h6 className="mb-0">Research for {county}</h6>
      <hr style={{ marginTop: "7px" }} className="mb-0 mx-0" />

      <p style={{ fontSize: 10 }} className="mb-0 p-2">
        <TextWithUrls text={researchToShow} />
      </p>
    </div>
  );
};

export default ResearchSection;

